import { config } from "../config";

// In chatService.ts, expand the interface:
interface ChatResponse {
  content?: string;
  response?: string;
  message?: string;
  responseId?: string;
  status?: string;
  search_results?: Array<{
    id: string;
    text: string;
    metadata?: Record<string, any>;
  }>;
}

export const sendChatMessage = async (
  userInput: string,
  token: string,
  previousResponseId: string | null,
): Promise<ChatResponse> => {
  const response = await fetch(config.api.ragChatEndpoint!, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      user_input: userInput,
      vector_store_id: config.api.vectorStoreId,
      previous_response_id: previousResponseId,
    }),
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  return await response.json();
};
